import { API } from "@/services"

export const DOCUMENT_APPROVAL_ENDPOINTS = {
  create(data={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 5 * 60 * 1000,
    })
  },
  list(params={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval`,
      method: 'GET',
      params,
    })
  },
  delete(document_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval/${document_id}`,
      method: 'DELETE',
      data,
    })
  },
  get(document_id,params={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval/${document_id}`,
      method: 'GET',
      params,
      timeout: 5 * 60 * 1000,
    })
  },
  reject(document_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval/${document_id}/reject`,
      method: 'PATCH',
      data,
    })
  },
  approve(document_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval/${document_id}/approve`,
      method: 'PATCH',
      data,
    })
  },
  checkByAI(document_id,data={}){
    return API.Axios.central_point.v1.request({
      url: `document-approval/${document_id}/check-by-ai`,
      method: 'PATCH',
      data,
    })
  },
}